import { render, staticRenderFns } from "./QuestionnaireCard.vue?vue&type=template&id=26dfcac8"
import script from "./QuestionnaireCard.vue?vue&type=script&lang=js"
export * from "./QuestionnaireCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports